export const routeMap = {
  '1-1': { path: '/ToufangBroad', name: 'ToufangBroad' },
  '1-2': { path: '/GameBroad', name: 'GameBroad' },
  '1-3': { path: '/ProjectBroad', name: 'ProjectBroad' },
  '1-4': { path: '/AdvertisingPyramid', name: 'AdvertisingPyramid' },
  '1-5': { path: '/CompanyConfig', name: 'CompanyConfig' },
  '1-6': { path: '/Test', name: 'Test' },
  '1-7': { path: '/Game3', name: 'Game3' },
  '1-8': { path: '/Game4', name: 'Game4' },
  '1-9': { path: '/GameConfig', name: 'GameConfig' },
  '1-10': { path: '/ToufangSelf', name: 'ToufangSelf' },
  '1-11': { path: '/ToufangSelf2', name: 'ToufangSelf2' },
  '1-21': { path: '/HelloWorld', name: 'HelloWorld' },
  '9-1': { path: '/PermissionManagement', name: 'PermissionManagement' },
  '2-1': { path: '/JuliangWarning', name: 'JuliangWarning' },
  '2-2': { path: '/WxWarning', name: 'WxWarning' },
  '2-3': { path: '/pluginRedirect', name: 'pluginRedirect' },
  '4-1': { path: '/ToufangWxBroad', name: 'ToufangWxBroad' },
  '4-2': { path: '/GameWxBroad2', name: 'GameWxBroad2' },
  '4-3': { path: '/GameWx3V1', name: 'GameWx3V1' },
  '4-4': { path: '/GameWx4', name: 'GameWx4' },
  '4-5': { path: '/GameConfigWx', name: 'GameConfigWx' },
  '4-6': { path: '/ToufangSelfWx', name: 'ToufangSelfWx' },
  '4-7': { path: '/WxHourData', name: 'WxHourData' },
  '4-8': { path: '/oneClickConfig', name: 'oneClickConfig' },
  '4-9': { path: '/gameLogin', name: 'gameLogin' },
  '4-10': { path: '/MpDataDub', name: 'MpDataDub' },
  '4-11': { path: '/GameWx3V2', name: 'GameWx3V2' },
  '4-13': { path: '/MpTencentPrediction', name: 'MpTencentPrediction' },
  '4-14': { path: '/TencentAiData', name: 'TencentAiData' },
  '4-15': { path: '/TencentAiRoiRules', name: 'TencentAiRoiRules' },
  '6-1': { path: '/VideoBroad', name: 'VideoBroad' },
  '6-2': { path: '/GameConfigSp', name: 'GameConfigSp' },
  '6-3': { path: '/MpVideoPrediction', name: 'MpVideoPrediction' },
  '6-4': { path: '/VideoBoostOrders', name: 'VideoBoostOrders' },
  '6-5': { path: '/VideoBoostAccountStats', name: 'VideoBoostAccountStats' },
  '6-6': { path: '/VideoBoostGameStats', name: 'VideoBoostGameStats' },
  '6-7': { path: '/VideoBoostAutoOrder', name: 'VideoBoostAutoOrder' },
  '10-1': { path: '/AigcVideoGenerator', name: 'AigcVideoGenerator' },
  '10-2': { path: '/AigcProviderConfig', name: 'AigcProviderConfig' },
  '10-3': { path: '/VideoStorageConfig', name: 'VideoStorageConfig' },
  '10-4': { path: '/AigcImageGenerator', name: 'AigcImageGenerator' },
  '10-5': { path: '/AigcQuotaGroups', name: 'AigcQuotaGroups' },
  '1-12': { path: '/TouFang', name: 'TouFang' },
  '1-13': { path: '/batchsAdd', name: 'batchsAdd' },
  '1-14': { path: '/campaignsIndex', name: 'campaignsIndex' },
  '1-15': { path: '/adgroupsIndex', name: 'adgroupsIndex' },
  '1-16': { path: '/adsIndex', name: 'adsIndex' },
  '1-17': { path: '/VideoLibrary', name: 'VideoLibrary' },
  '1-18': { path: '/smart-plus-report', name: 'SmartPlusMaterialReport' },
  '1-19': { path: '/tiktok/campaign-report', name: 'CampaignReport' },
  '1-20': { path: '/tiktok/campaign-rule', name: 'CampaignRuleManager' },
  '1-22': { path: '/hourly-revenue-monitor', name: 'HourlyRevenueMonitor' },
  '1-23': { path: '/revenue-analysis', name: 'RevenueAnalysis' },
  '1-24': { path: '/ToufangGamePermission', name: 'ToufangGamePermission' },
  '1-25': { path: '/ToufangY4HistoryMatrix', name: 'ToufangY4HistoryMatrix' },
  '1-26': { path: '/tiktok/advertiser-report', name: 'AdvertiserReport' },
  '1-27': { path: '/tiktok/ad-create-logs', name: 'AdCreateLog' },
  '1-31': { path: '/tiktok/developer-iaa-data', name: 'DeveloperIaaData' },
  '1-28': { path: '/OceanEngineAccountDirectory', name: 'OceanEngineAccountDirectory' },
  '1-29': { path: '/OceanEngineOperationLogs', name: 'OceanEngineOperationLogs' },
  '1-30': { path: '/OceanEngineAiData', name: 'OceanEngineAiData' },
  '1-32': { path: '/ProjectSummaryHistory', name: 'ProjectSummaryHistory' }
}

export const moduleNames = {
  projectSummary: '\u9879\u76ee\u6c47\u603b',
  juliang: '巨量抖音',
  tiktok: 'tiktok抖音',
  tencent: '腾讯广告',
  video: '视频号',
  aigc: 'AI工具',
  warning: '报警监控',
  admin: '管理'
}

export const editableModules = ['juliang', 'projectSummary', 'tiktok', 'tencent', 'video', 'aigc', 'warning']

export const allMenuItems = {
  juliang: [
    { index: '1-1', name: '投放看板' },
    { index: '1-21', name: '系统监控' },
    { index: '1-10', name: '个人看板' },
    { index: '1-8', name: '游戏维度汇总' },
    { index: '1-7', name: '创意维度明细' },
    { index: '1-9', name: '游戏分类' },
    { index: '1-12', name: '微信游戏投放' },
    { index: '1-24', name: '用户游戏权限' },
    { index: '1-25', name: 'Y4授权历史数据' },
    { index: '1-28', name: '巨量账号目录' }
  ],
  projectSummary: [
    { index: '1-32', name: '\u9879\u76ee\u6c47\u603b' }
  ],
  tencent: [
    { index: '4-1', name: '投放看板' },
    { index: '4-4', name: '游戏维度(总)' },
    { index: '4-11', name: '微信广告维度' },
    { index: '4-5', name: '游戏分类' },
    { index: '4-6', name: '个人微信看板' },
    { index: '4-7', name: '微信小时数据' },
    { index: '4-8', name: '一键起量配置' },
    { index: '4-9', name: '微信一键登录' },
    { index: '4-10', name: '微信ROI数据' },
    { index: '4-13', name: '腾讯预估倍率' },
    { index: '4-3', name: '游戏维度子表(新)' }
  ],
  video: [
    { index: '6-1', name: '投放看板' },
    { index: '6-2', name: '游戏配置' },
    { index: '6-3', name: '视频号预估倍率' },
    { index: '6-4', name: '加热订单看板' },
    { index: '6-5', name: '加热账号看板' },
    { index: '6-6', name: '加热游戏看板' },
    { index: '6-7', name: '加热下单配置' }
  ],
  aigc: [
    { index: '10-1', name: 'AI视频生成' },
    { index: '10-4', name: 'AI图片生成' },
    { index: '10-5', name: 'AI分组额度' },
    { index: '10-2', name: '服务商配置' },
    { index: '10-3', name: '存储配置' }
  ],
  warning: [
    { index: '2-1', name: '巨量配置' },
    { index: '2-2', name: '广点通配置' },
    { index: '2-3', name: '外部渠道' }
  ],
  tiktok: [
    { index: '1-13', name: '批量投放' },
    { index: '1-17', name: '视频库' },
    { index: '1-18', name: '智能+报表' },
    { index: '1-19', name: '广告系列报表' },
    { index: '1-26', name: '广告主报表' },
    { index: '1-27', name: '批量创建日志' },
    { index: '1-31', name: 'Developer IAA数据' },
    { index: '1-20', name: '广告系列规则' },
    { index: '1-22', name: '小时回收监控' },
    { index: '1-23', name: '收入分析' }
  ],
  admin: [
    { index: '9-1', name: '用户与权限' }
  ]
}


const tencentAiMenu = { index: '4-14', name: '\u817e\u8baf\u5e7f\u544aAI\u6570\u636e' }
if (!allMenuItems.tencent.some(item => item.index === tencentAiMenu.index)) {
  const predictionIndex = allMenuItems.tencent.findIndex(item => item.index === '4-13')
  allMenuItems.tencent.splice(predictionIndex >= 0 ? predictionIndex + 1 : allMenuItems.tencent.length, 0, tencentAiMenu)
}

const tencentAiRoiRuleMenu = { index: '4-15', name: '\u0052\u004f\u0049\u81ea\u52a8\u89c4\u5219' }
if (!allMenuItems.tencent.some(item => item.index === tencentAiRoiRuleMenu.index)) {
  const aiDataIndex = allMenuItems.tencent.findIndex(item => item.index === '4-14')
  allMenuItems.tencent.splice(aiDataIndex >= 0 ? aiDataIndex + 1 : allMenuItems.tencent.length, 0, tencentAiRoiRuleMenu)
}

const oceanEngineOperationLogMenu = { index: '1-29', name: '\u5de8\u91cf\u64cd\u4f5c\u65e5\u5fd7' }
if (!allMenuItems.juliang.some(item => item.index === oceanEngineOperationLogMenu.index)) {
  const accountDirectoryIndex = allMenuItems.juliang.findIndex(item => item.index === '1-28')
  allMenuItems.juliang.splice(accountDirectoryIndex >= 0 ? accountDirectoryIndex + 1 : allMenuItems.juliang.length, 0, oceanEngineOperationLogMenu)
}

const oceanEngineAiDataMenu = { index: '1-30', name: '\u5de8\u91cf\u5e7f\u544aAI\u6570\u636e' }
if (!allMenuItems.juliang.some(item => item.index === oceanEngineAiDataMenu.index)) {
  const operationLogIndex = allMenuItems.juliang.findIndex(item => item.index === '1-29')
  allMenuItems.juliang.splice(operationLogIndex >= 0 ? operationLogIndex + 1 : allMenuItems.juliang.length, 0, oceanEngineAiDataMenu)
}
